module.exports = __webpack_public_path__ + "img/macbook-app2.6076cf81.png";